import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  currencyUtil
} from '@/util'

const areaNameList = [
  'order.order_purchase-order-info',
  'order.order_desired-warehousing-location',
  'order.order_order-info'
]

const interfaceObj = {
  title: '',
  name: '',
  postalCode: '',
  address: '',
  phone: ''
}

function setRegisterInfo(clientData) {
  const register = clientData.client

  const registerInvoice = register.invoiceInfo
  const invoiceInfo = {
    ...interfaceObj,
    title: areaNameList[0],
    // supplierName: registerInvoice.orderSupplierName,
    name: commonUtil.getSeparateWordsBySpace([
      registerInvoice.section,
      registerInvoice.rep
    ]),
    postalCode: commonUtil.formatPostalCode(
      registerInvoice.postalCode,
      registerInvoice.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerInvoice.country.value,
        commonUtil.getRegionValue(registerInvoice.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerInvoice.address1,
        registerInvoice.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      registerInvoice.phone.phoneNumber,
      registerInvoice.phone.countryCode.value,
      false
    ),
    fax: countryCallingCodeUtil.formatPhoneNumber(
      registerInvoice.fax.phoneNumber,
      registerInvoice.fax.countryCode.value,
      false
    )
  }

  const registerReceiver = register.receiverInfo
  const receiverInfo = {
    ...this.interfaceObj,
    title: areaNameList[1],

    postalCode: commonUtil.formatPostalCode(
      registerReceiver.postalCode,
      registerReceiver.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerReceiver.country.value,
        commonUtil.getRegionValue(registerReceiver.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerReceiver.address1,
        registerReceiver.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(registerReceiver.phone.phoneNumber, ''),
      registerReceiver.phone.countryCode.value,
      false
    )
  }

  const requiredInfo = register.orderInfo
  const sales = {
    ...this.interfaceObj,
    title: areaNameList[2],

    currency: currencyUtil.getCurrencyIdInfo(requiredInfo.currency.value),
    orderDate: requiredInfo.orderDate,
    deliveryDate: requiredInfo.deliveryDate
  }

  return [invoiceInfo, receiverInfo, sales]
}

function setHistoryInfo(history) {
  const invoiceInfo = {
    ...interfaceObj,
    title: areaNameList[0],
    supplierName: history.orderSupplierName,
    name: commonUtil.getSeparateWordsBySpace([
      history.orderSection,
      history.orderPerson
    ]),
    postalCode: commonUtil.formatPostalCode(
      history.orderPostcode,
      history.orderAddressCountryId
    ),
    address:
      countryUtil.getRegionInfo(
        history.orderAddressCountryId,
        history.orderRegionId
      ).label +
      commonUtil.getSeparateWordsBySpace([
        history.orderAddress1,
        history.orderAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      history.orderPhoneNumber,
      history.orderPhoneNumberCountryId,
      false
    ),
    fax: countryCallingCodeUtil.formatPhoneNumber(
      history.orderFax,
      history.orderFaxNumberCountryId,
      false
    )
  }

  const receiverInfo = {
    ...this.interfaceObj,
    title: areaNameList[1],
    postalCode: commonUtil.formatPostalCode(
      history.preferredPostalCode,
      history.preferredAddressCountryId
    ),
    address:
      countryUtil.getRegionInfo(
        history.preferredAddressCountryId,
        history.preferredRegionId
      ).label +
      commonUtil.getSeparateWordsBySpace([
        history.preferredAddress1,
        history.preferredAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(history.preferredPhoneNumber, ''),
      history.preferredPhoneNumberCountryId,
      false
    )
  }

  const sales = {
    ...this.interfaceObj,
    title: areaNameList[2],
    currency: currencyUtil.getCurrencyIdInfo(history.currencyId),
    orderDate: history.orderDate,
    deliveryDate: history.preferredDate
  }

  return [invoiceInfo, receiverInfo, sales]
}

export default { setRegisterInfo, setHistoryInfo }
